import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Network from '../Components/Requests';
import { globalConfig } from '../configuration/config';
import AuthService from '../Services/AuthService';
import {
  setAccessToken,
  setActorNumber,
  setCalculationName,
  setChatGuid,
  setExtraUrlParams,
  setGuidCalculation,
  setProject,
  setTypes,
  setUserGuid,
  setRoomGuid,
} from '../store/reducers/inviteLinkSlice';
import InviteLinkRedirect from './InviteLinkRedirect';

export default function ReadLink() {
  const [token, setToken] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [linkGuid, setLinkGuid] = useState(null);
  const [continueFlow, setContinueFlow] = useState(false);

  const [authService, setAuthService] = useState(new AuthService());
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const checkUserType = async () => {
      const params = new URL(document.location).searchParams;
      const guid = params.get('id');
      setLinkGuid(guid);

      try {
        const res = await fetch(`${globalConfig.config.common.api}/Users/GetUserInfo`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await res.json();

        if (data.idUserType && data.idUserType !== 1) {
          // Пользователь не клиент — показать подтверждение
          setShowConfirm(true);
        } else {
          // Клиент — сразу продолжаем
          setContinueFlow(true);
        }
      } catch (err) {
        console.error('Ошибка при проверке пользователя:', err);
        setContinueFlow(true); // если не смогли проверить — продолжаем
      }
    };

    checkUserType();
  }, []);

  useEffect(() => {
    if (!continueFlow || !linkGuid) return;

    const processAsync = async () => {
      const send = await new Network().JoinProjectByLink(
        linkGuid,
        globalConfig.config.auth.client_id,
      );
      if (!send) {
        authService.logout();
        return;
      }

      new Network().IncrementCounter(send.projectGuid, 2, send.userGuid);

      const obj = { access_token: send.accessToken };
      localStorage.setItem(
        `oidc.user:${globalConfig.config.auth.authority}:${globalConfig.config.auth.client_id}`,
        JSON.stringify(obj),
      );
      localStorage.setItem('types', send.linkType);
      localStorage.setItem('token', send.accessToken);
      localStorage.setItem('project', send.projectGuid);
      localStorage.setItem('guidCalculation', send.guidCalculation);
      localStorage.setItem('calculationName', send.calculationName);
      localStorage.setItem('room', send.room);
      localStorage.setItem('actorNumber', send.actorNumber);
      localStorage.setItem('joinLink', true);

      dispatch(setTypes(send.linkType));
      dispatch(setAccessToken(send.accessToken));
      dispatch(setProject(send.projectGuid));
      dispatch(setGuidCalculation(send.guidCalculation));
      dispatch(setCalculationName(send.calculationName));
      dispatch(setActorNumber(send.actorNumber));
      dispatch(setExtraUrlParams(send.extraUrlParams));
      dispatch(setChatGuid(send.chatGuid));
      dispatch(setUserGuid(send.userGuid));
      dispatch(setRoomGuid(send.room));

      setToken(true);
    };

    processAsync();
  }, [continueFlow, linkGuid]);

  if (token) return <InviteLinkRedirect />;

  if (showConfirm) {
    return (
      <div style={{ padding: 32, maxWidth: 400, margin: 'auto', textAlign: 'center' }}>
        <p style={{ fontSize: 18 }}>
          Данная ссылка предназначена для клиента.
          <br />
          Переход по ней приведет к выходу из системы и входу под клиентом.
          <br />
          <br />
          Продолжить?
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginTop: 24 }}>
          <button
            onClick={() => setContinueFlow(true)}
            style={{
              padding: '10px 20px',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
            }}>
            Да
          </button>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '10px 20px',
              background: '#e0e0e0',
              color: '#333',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
            }}>
            Нет
          </button>
        </div>
      </div>
    );
  }

  return <></>;
}
